import { gql } from '@apollo/client';
import CommonFragments from 'features/common/fragments';

export const SCHEDULE_TYPE_CELL_PARAM_TEMPLATE_DELETED = gql`
  subscription scheduleTypeCellParamTemplateDeleted {
    scheduleTypeCellParamTemplateDeleted {
      scheduleTypeCellParamTemplateId
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;
